import { useMutation } from "@tanstack/react-query";
import apiClient from "@apis/index";
import Routes from "./routes";
import {
  ShopifyCreateRequest,
  ShopifyCreateProductResponse,
  ShopifyCartProperties,
  addToShopifyCart,
} from "@utils/shopifyCartIntegration";

export type CreateShopifyProductVariables = {
  payload: ShopifyCreateRequest;
  quantity: number;
  properties?: ShopifyCartProperties;
};

export const useCreateShopifyProduct = () => {
  return useMutation({
    mutationFn: (variables: CreateShopifyProductVariables) =>
      apiClient.post<ShopifyCreateProductResponse>(
        Routes.SHOPIFY_CREATE_PRODUCT,
        variables.payload
      ),
    onSuccess: (response, variables) => {
      const firstVariantId = response?.data?.product?.[0]?.variants?.[0]?.id;

      if (firstVariantId) {
        addToShopifyCart(
          firstVariantId,
          variables.quantity,
          variables.properties
        );
      } else {
        console.error("No product variant found in Shopify response");
      }
    },
  });
};
